import classnames from "classnames/bind";
import Config from "config";
import React, { createRef, useEffect, useState } from "react";

const $ = window.$;
export class SelectList extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.className) {
      this.className = this.props.className;
    } else {
      this.className = "select-field mb-3";
    }

    if (this.props.templateSelection) {
      this.templateSelection = this.props.templateSelection;
    } else {
      this.templateSelection = "";
    }

    this.minimumResultsForSearch = this.props.minimumResultsForSearch;

    // console.log("select name",this.className)
    this.handleChange = this.handleChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  handleChange(e) {
    // console.log(e)

    if (this.props.clearOption && e.params.args.data.id == "clear") {
      this.props.OnformsDataChange({
        field: this.props.fieldName,
        value: "",
      });
    } else {
      this.props.OnformsDataChange({
        field: this.props.fieldName,
        value: e.params.args.data.id,
      });
    }

    e.preventDefault();
    this.$el.select2("close");
  }

  handleOpen() {
    console.log("this.props.placeholderSearch", this.props.placeholderSearch);
    $("input.select2-search__field").prop(
      "placeholder",
      this.props.placeholderSearch
    );
  }

  componentDidMount() {
    //const props = this.props
    this.$el = $(this.el);

    if (this.$el.data("select2")) {
      this.$el.select2("destroy");
    }

    this.select2Setting = {
      placeholder: this.props.placeholder,
      allowClear: true,
      //onChange: this.handleChange
    };

    if (this.props.dropdownParent) {
      this.select2Setting.dropdownParent = $(this.props.dropdownParent);
    }

    if (this.props.fieldName === "station") {
      this.select2Setting.templateResult = function (idioma) {
        if (idioma.id === "clear") {
          var $span = $(
            "<span class='d-flex align-items-center justify-content-between'>" +
            idioma.text +
            "</span>"
          );
        }
        else if (idioma.title == "bts") {
          var $span = $(
            "<span class='d-flex align-items-center justify-content-between'>" +
            idioma.text +
            "<img src='/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/bts.png' width='24'/></span>"
          );
        } else {
          var $span = $(
            "<span class='d-flex align-items-center justify-content-between'>" +
            idioma.text +
            "<img src='/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/mrt.png' width='24'/></span>"
          );
        }
        return $span;
      };

      this.select2Setting.templateSelection = function (idioma) {
        if (idioma.id) {
          if (idioma.title == "bts") {
            var $span = $(
              "<span class='d-flex align-items-center justify-content-between'>" +
              idioma.text +
              "<img src='/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/bts.png' width='24' style='margin-right: 10px;'/></span>"
            );
          } else {
            var $span = $(
              "<span class='d-flex align-items-center justify-content-between'>" +
              idioma.text +
              "<img src='/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/mrt.png' width='24' style='margin-right: 10px;'/></span>"
            );
          }
        } else {
          var $span = $("<span>" + idioma.text + "</span>");
        }
        return $span;
      };
    }

    if (this.props.templateSelection) {
      this.select2Setting.templateSelection = this.props.templateSelection;
    }

    if (this.props.minimumResultsForSearch) {
      this.select2Setting.minimumResultsForSearch =
        this.props.minimumResultsForSearch;
    }

    // console.log(this.select2Setting)
    this.$el
      .select2(this.select2Setting)
      .one("select2:open", this.handleOpen)
      .on("select2:selecting", this.handleChange);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.option !== this.props.option) {
      this.$el.select2("destroy");
      this.$el
        .select2(
          this.select2Setting
          //     {
          //     placeholder: this.props.placeholder,
          //     allowClear: true,
          //     //onChange: this.handleChange
          // }
        )
        .one("select2:open", this.handleOpen)
        .on("select2:selecting", this.handleChange);
      // console.log(`SelectList ${this.props.fieldName} Updated`)
    }
    if (prevProps.value !== this.props.value) {
      this.$el.trigger("change.select2");
    }
  }

  render() {
    return (
      <div className={this.className}>
        <select
          name={this.props.id}
          id={this.props.id}
          value={this.props.value}
          ref={(el) => (this.el = el)}
          readOnly
        >
          {!this.props.notShowEmptyOption && <option></option>}
          {this.props.clearOption && <option value="clear">ทั้งหมด</option>}
          {Array.isArray(this.props.option) &&
            this.props.option.map((item, index) => renderChild(item, index))}
        </select>
      </div>
    );
  }
}

function renderChild(item, index) {
  return (
    <option key={item.value} value={item.value} title={item.title}>
      {item.text}
    </option>
  );
}

export class IonRange extends React.Component {
  constructor(props) {
    super(props);
    //this.formsDataChange = props.formsDataChange;
    //this = props;
    // Don't call this.setState() here!
    // this.state = { counter: 0 };
    // this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(data) {
    this.props.OnformsDataChange(
      this.props.fieldName,
      data.from_value,
      (new Set([data.from, data.to, data.max]).size === 1) ? "" : data.to_value
    );
  }

  componentDidMount() {
    //const props = this.props
    // console.log(this.props, " <--slider value");
    this.$el = $(this.el);
    this.$el.ionRangeSlider({
      skin: "big",
      type: "double",
      grid: false,
      min: this.props.min,
      max: this.props.max,
      from: this.props.from,
      to: this.props.to,
      step: this.props.step,
      values: this.props.values,
      hide_from_to: true,
      hide_min_max: true,
      // skin: "round",
      // prettify_separator: ",",
      //onChange: this.handleChange
      onFinish: this.handleChange,
    });
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (
      this.props.max !== prevProps.max ||
      this.props.min !== prevProps.min ||
      this.props.step !== prevProps.step ||
      this.props.count !== prevProps.count
    ) {
      this.$el.data("ionRangeSlider").update({
        min: this.props.min,
        max: this.props.max,
        step: this.props.step,
        from: this.props.from,
        to: this.props.to,
      });
    }
  }

  componentWillUnmount() {
    this.$el.data("ionRangeSlider").destroy();
  }

  render() {
    return (
      <div className="rangeSlider-field">
        <input ref={(el) => (this.el = el)} />
      </div>
    );
  }
}

export const RangeInput = (props) => {
  const [Start, setStartValue] = useState("");
  const [End, setEndValue] = useState("");
  const [StartList, setStartListValue] = useState(props.values);
  const [EndList, setEndListValue] = useState(props.values);
  const dropdown = createRef();

  function clickRangeInput() {
    if ($(".range-dropdown.active").length > 0) {
      $(".range-dropdown.active").removeClass("active");
    }
    $(dropdown.current).addClass("active");
    setStart();
  }

  function setStart() {
    $(dropdown.current).addClass("start");
    $(dropdown.current).removeClass("end");
  }

  function setEnd() {
    $(dropdown.current).addClass("end");
    $(dropdown.current).removeClass("start");
  }

  function startClick(item) {
    // console.log("start",item)
    setStartValue(item);
    const index = StartList.indexOf(item);
    if (index > 0) {
      setEndListValue(
        StartList.slice(0, 1).concat(
          StartList.slice(StartList.indexOf(item) + 1)
        )
      );
    } else {
      setEndListValue(StartList);
    }
    props.OnformsDataChange(props.fieldName, item, "");
    setEnd();
  }

  function endClick(item) {
    // console.log("end",item)
    setEndValue(item);
    props.OnformsDataChange(props.fieldName, Start, item);
    $(dropdown.current).removeClass("active");
  }

  function renderStartChild(item, index) {
    return (
      <li key={index} value={item} onClick={(e) => startClick(item)}>
        {item}
      </li>
    );
  }

  function renderEndChild(item, index) {
    return (
      <li key={index} value={item} onClick={(e) => endClick(item)}>
        {item}
      </li>
    );
  }

  return (
    <div className="rangeInput-wrap">
      <input
        id="price-range-text"
        type="text"
        className="normal-input"
        name="price-range-text"
        placeholder={props.placeholder}
        readOnly
        onClick={clickRangeInput}
        value={props.value}
      />
      <div className={classnames(["range-dropdown"])} ref={dropdown}>
        <div className="range-header">
          <div className="range-btn start" onClick={setStart}>
            เริ่มต้น
          </div>
          <div>-</div>
          <div className="range-btn end" onClick={setEnd}>
            สิ้นสุด
          </div>
        </div>
        <div className="range-body">
          <ul className="option-list start">
            {StartList.map((item, index) => renderStartChild(item, index))}
          </ul>
          <ul className="option-list end">
            {EndList.map((item, index) => renderEndChild(item, index))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export const CounterInput = (props) => {
  function decrease() {
    if (props.value > props.min) {
      props.OnformsDataChange({
        field: props.fieldName,
        value: props.value - 1,
      });
    }
  }

  function increase() {
    if (props.value < props.max) {
      props.OnformsDataChange({
        field: props.fieldName,
        value: props.value + 1,
      });
    }
  }

  return (
    <div className="input-counter-wrap">
      <div className="decrease-button" onClick={decrease}>
        <i className="ic-npa ic-npa-icon-minus"></i>
      </div>
      <input
        type="text"
        className="input-counter"
        data-min={props.min}
        data-max={props.max}
        value={props.value}
        readOnly
      />
      <div className="increase-button" onClick={increase}>
        <i className="ic-npa ic-npa-icon-plus"></i>
      </div>
    </div>
  );
};

export const CheckBoxIonInput = (props) => {
  function check() {
    props.OnformsDataChange(props.fieldName, !props.value, props.group);
  }

  return (
    <>
      <input
        type="checkbox"
        name="property-type"
        checked={props.value}
        hidden
        readOnly
      />
      <label className="radio-item" onClick={check}>
        <div className="custom-check-icon"></div>
        <i className={`ic-npa ic-npa-icon-${props.fieldName}`}></i>
      </label>
      <p>{props.name}</p>
    </>
  );
};

export const CheckBoxCustomInput = (props) => {
  function check() {
    props.OnformsDataChange(props.fieldName, !props.value, props.group);
  }

  return (
    <>
      <input
        type="checkbox"
        name="property-type"
        checked={props.value}
        hidden
        readOnly
      />
      <label className="custom-check" onClick={check}>
        <div className="custom-check-icon"></div>
        <i className={`ic-npa ic-npa-icon-${props.fieldName}`}></i>
        {props.spanText && <span>{props.spanText}</span>}
      </label>
      <p dangerouslySetInnerHTML={{ __html: props.name }}></p>
    </>
  );
};

export class CalcSelectList extends React.Component {
  constructor(props) {
    super(props);

    // console.log("select name",this.className)
    this.handleChange = this.handleChange.bind(this);
    this.renderChild = this.renderChild.bind(this);
  }

  handleChange(e) {
    // console.log(e)
    this.props.OnformsDataChange(this.props.fieldName, e.params.args.data.id);
    e.preventDefault();
    this.$el.select2("close");
  }

  componentDidMount() {
    //const props = this.props
    this.$el = $(this.el);

    if (this.$el.data("select2")) {
      this.$el.select2("destroy");
    }

    this.select2Setting = {
      placeholder: this.props.placeholder,
      allowClear: true,
      minimumResultsForSearch: -1,
      dropdownCssClass: "cs-dropdown",
    };

    this.$el
      .select2(this.select2Setting)
      .on("select2:selecting", this.handleChange);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.option !== this.props.option) {
      this.$el.select2("destroy");
      this.$el
        .select2(this.select2Setting)
        .on("select2:selecting", this.handleChange);
      // console.log(`SelectList ${this.props.fieldName} Updated`)
    }
    if (prevProps.value !== this.props.value) {
      this.$el.trigger("change.select2");
    }
  }

  renderChild(item) {
    return (
      <option key={item.value} value={item.value} title={item.title}>
        {item.text}
      </option>
    );
  }

  render() {
    return (
      <div className="calculate-group">
        <label>{this.props.label}</label>
        <select
          id={"Cal" + this.props.fieldName}
          value={this.props.value}
          ref={(el) => (this.el = el)}
          readOnly
        >
          <option></option>
          {Array.isArray(this.props.option) &&
            this.props.option.map((item) => this.renderChild(item))}
        </select>
        {this.props.errorMessage && (
          <span className="error-message" style={{ display: "block" }}>
            {this.props.errorMessage}
          </span>
        )}
      </div>
    );
  }
}

export const CalcInputField = (props) => {
  // console.log("InputField Render",props.fieldName)

  function OnformsDataChange(e) {
    console.log("on change", e.target.value);
    props.OnformsDataChange(props.fieldName, e.target.value);
  }

  function OnformsBlur(e) {
    if (props.formsBlur) {
      var value = e.target.value;
      // if (value === props.placeholder) {
      //     value = '';
      // }
      console.log("on change", value);
      props.formsBlur(props.fieldName, value);
    }
  }

  return (
    <div className="calculate-group">
      <label
        dangerouslySetInnerHTML={{
          __html: props.label ? props.label : "\u00A0",
        }}
      ></label>
      <input
        placeholder={props.placeholder}
        value={props.value}
        onChange={OnformsDataChange}
        onBlur={OnformsBlur}
        maxLength={props.maxLength}
        id={"Cal" + props.fieldName}
      />
      {props.errorMessage && (
        <span className="error-message" style={{ display: "block" }}>
          {props.errorMessage}
        </span>
      )}
    </div>
  );
};

export class DropLeadSelectList extends React.Component {
  constructor(props) {
    super(props);

    // console.log("select name",this.className)
    this.handleChange = this.handleChange.bind(this);
    this.renderChild = this.renderChild.bind(this);
  }

  handleChange(e) {
    // console.log(e)
    this.props.OnformsDataChange(this.props.fieldName, e.params.args.data.id);
    e.preventDefault();
    this.$el.select2("close");
  }

  componentDidMount() {
    //const props = this.props
    this.$el = $(this.el);

    if (this.$el.data("select2")) {
      this.$el.select2("destroy");
    }

    this.select2Setting = {
      placeholder: this.props.placeholder,
      allowClear: true,
      minimumResultsForSearch: -1,
      dropdownCssClass: "border-dropdown",
    };

    this.$el
      .select2(this.select2Setting)
      .on("select2:selecting", this.handleChange);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.option !== this.props.option) {
      this.$el.select2("destroy");
      this.$el
        .select2(this.select2Setting)
        .on("select2:selecting", this.handleChange);
      // console.log(`SelectList ${this.props.fieldName} Updated`)
    }
    if (prevProps.value !== this.props.value) {
      this.$el.trigger("change.select2");
    }
  }

  renderChild(item) {
    return (
      <option key={item.value} value={item.value} title={item.title}>
        {item.text}
      </option>
    );
  }

  render() {
    return (
      <div className="form-item">
        <label>{this.props.label}</label>
        <div className="select-field">
          <select
            value={this.props.value}
            ref={(el) => (this.el = el)}
            readOnly
          >
            <option></option>
            {Array.isArray(this.props.option) &&
              this.props.option.map((item) => this.renderChild(item))}
          </select>
        </div>
        {this.props.errorMessage && (
          <span className="error-message" style={{ display: "block" }}>
            {this.props.errorMessage}
          </span>
        )}
      </div>
    );
  }
}

export const DropLeadInputField = (props) => {
  // console.log("InputField Render",props.fieldName)

  function OnformsDataChange(e) {
    props.OnformsDataChange(props.fieldName, e.target.value);
  }

  function OnformsBlur(e) {
    if (props.formsBlur) {
      var value = e.target.value;
      props.formsBlur(props.fieldName, value);
    }
  }

  return (
    <div className="form-item">
      <label
        dangerouslySetInnerHTML={{
          __html: props.label ? props.label : "\u00A0",
        }}
      ></label>
      <input
        placeholder={props.placeholder}
        className="normal-input"
        value={props.value}
        onChange={OnformsDataChange}
        onBlur={OnformsBlur}
        maxLength={props.maxLength}
        inputMode={props.inputmode}
      />
      {props.errorMessage && (
        <span className="error-message" style={{ display: "block" }}>
          {props.errorMessage}
        </span>
      )}
    </div>
  );
};
